(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/functions.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/functions.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function productsPerAmountFromCart(cart) {
  const products = [];
  for (let i = 0; i < cart.length; i++) {
    const item = cart[i];
    for (let j = 0; j < item.amount; j++) {
      products.push(item.product);
    }
  }
  return products;
}
function deliveryDateHasChanged(_ref) {
  let date = _ref.date,
    time = _ref.time,
    currentDate = _ref.currentDate;
  const iso = dateFns.parseISO("".concat(date, "T").concat(time));
  return dateFns.differenceInMinutes(iso, currentDate) >= 1;
}
function createJupiterVoucherPaymentObject() {
  let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$cart = _ref2.cart,
    cart = _ref2$cart === void 0 ? [] : _ref2$cart,
    name = _ref2.name,
    phone = _ref2.phone,
    email = _ref2.email,
    receiverType = _ref2.receiverType,
    personalGreeting = _ref2.personalGreeting,
    greeting = _ref2.greeting,
    price = _ref2.price,
    date = _ref2.date,
    time = _ref2.time;
  let deliveryDate = null;
  if (deliveryDateHasChanged({
    date,
    time,
    currentDate: Date.now()
  })) {
    deliveryDate = "".concat(date, "T").concat(time);
  }
  return {
    deliveryDate,
    recipientName: name,
    recipientPhoneNumber: receiverType === 'phone' ? phone : undefined,
    recipientEmail: receiverType === 'email' ? email : undefined,
    message: greeting,
    personalGreeting,
    price,
    products: cart.map(_ref3 => {
      var _product$type;
      let product = _ref3.product,
        amount = _ref3.amount;
      return {
        name: product.productName,
        type: (_product$type = product.type) === null || _product$type === void 0 ? void 0 : _product$type.split(':')[0],
        productId: product.productId,
        skinId: product.skinId,
        skinPosition: product.productVariation || 0,
        count: amount,
        value: product.productPrice
      };
    })
  };
}
function calculateCartSum() {
  let _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$cart = _ref4.cart,
    cart = _ref4$cart === void 0 ? [] : _ref4$cart;
  return cart.reduce((sum, _ref5) => {
    let product = _ref5.product,
      amount = _ref5.amount;
    return parseFloat(product.productPrice) * amount + sum;
  }, 0);
}
function calculateNumberOfProductsInCart() {
  let _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref6$cart = _ref6.cart,
    cart = _ref6$cart === void 0 ? [] : _ref6$cart;
  return cart.reduce((sum, _ref7) => {
    let amount = _ref7.amount;
    return amount + sum;
  }, 0);
}
function findProductByIdAndVariation() {
  let _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    products = _ref8.products,
    productId = _ref8.productId,
    productVariation = _ref8.productVariation,
    type = _ref8.type,
    skinId = _ref8.skinId;
  if (!products) {
    return null;
  }
  let product = null;
  for (let i = 0; i < products.length; i++) {
    if (products[i].productId === productId && products[i].productVariation === productVariation && products[i].type === type && (!skinId || products[i].skinId === skinId)) {
      product = products[i];
      break;
    }
  }
  return product;
}
function appendProductToCart() {
  let _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    cart = _ref9.cart,
    productId = _ref9.productId,
    productVariation = _ref9.productVariation,
    type = _ref9.type,
    amount = _ref9.amount,
    products = _ref9.products,
    skinId = _ref9.skinId;
  return buildCart({
    cart,
    productId,
    productVariation,
    type,
    isAppend: true,
    newAmount: amount,
    products,
    lastUpdatedFromType: svs.tickets_giftshop.constants.cart.APPEND,
    skinId
  });
}
function setProductToCart() {
  let _ref0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    cart = _ref0.cart,
    productId = _ref0.productId,
    productVariation = _ref0.productVariation,
    amount = _ref0.amount,
    products = _ref0.products,
    type = _ref0.type,
    skinId = _ref0.skinId;
  return buildCart({
    cart,
    productId,
    productVariation,
    type,
    newAmount: amount,
    isAppend: false,
    products,
    lastUpdatedFromType: svs.tickets_giftshop.constants.cart.SET,
    skinId
  });
}
function locationAssign(url) {
  window.location.assign(window.location.origin + url);
}

function parseTicketQuery(query, jupiterProducts) {
  let decodedQuery;
  try {
    decodedQuery = decodeURIComponent(query);
  } catch (e) {
    svs.tickets_giftshop.logger.error(e);
    return [];
  }
  if (typeof query !== 'string' || !query) {
    return [];
  }
  const tickets = decodedQuery.split(',');
  const ticketMap = tickets.reduce((map, ticket) => {
    const existingTicket = map.get(ticket);
    if (existingTicket) {
      existingTicket.count += 1;
    } else {
      const type = ticket.split(':')[0];
      let variation = ticket.split(':')[1];
      if (variation) {
        variation = Number(variation) || 1;
      } else {
        var _$find;
        variation = ((_$find = _.find(jupiterProducts, product => product.type.split(':')[0] === type)) === null || _$find === void 0 ? void 0 : _$find.productVariation) || 1;
      }
      map.set(ticket, {
        count: 1,
        variation,
        type: ticket
      });
    }
    return map;
  }, new Map());
  return Array.from(ticketMap.values());
}
function GiftformValidator() {
  const hasRegexUnicodeSupport = new RegExp().unicode === false;
  const allowedCharactersRegex = /[A-Za-z0-9!?.,;:\\\-_()<>^/\n áéíóúýæþðåäöÁÉÍÓÚÝÆÞÐÅÄÖ]+/g;
  const allowedEmojisRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
  const allowedVariationSelectorsRegex = /[\uFE00-\uFE0F]/g;
  function hasInvalidGreetingsCharacters(text) {
    if (typeof text !== 'string') {
      throw Error('must be a string');
    }
    text = text.replace(allowedCharactersRegex, '');
    if (hasRegexUnicodeSupport) {
      text = text.replace(allowedEmojisRegex, '');
      text = text.replace(allowedVariationSelectorsRegex, '');
    }
    return text.length > 0;
  }
  return {
    hasInvalidGreetingsCharacters
  };
}
function byteSize(text) {
  let countAsEscaped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let size = unescape(encodeURIComponent(text)).length;
  if (countAsEscaped) {
    size += text.split('\n').length - 1;
  }
  return size;
}
svs.tickets_giftshop.functions = {
  createJupiterVoucherPaymentObject,
  calculateCartSum,
  calculateNumberOfProductsInCart,
  deliveryDateHasChanged,
  findProductByIdAndVariation,
  appendProductToCart,
  setProductToCart,
  locationAssign,
  parseTicketQuery,
  productsPerAmountFromCart,
  giftformValidator: new GiftformValidator(),
  byteSize
};

function buildCart() {
  let _ref1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref1$cart = _ref1.cart,
    cart = _ref1$cart === void 0 ? [] : _ref1$cart,
    productId = _ref1.productId,
    productVariation = _ref1.productVariation,
    type = _ref1.type,
    _ref1$newAmount = _ref1.newAmount,
    newAmount = _ref1$newAmount === void 0 ? 1 : _ref1$newAmount,
    isAppend = _ref1.isAppend,
    products = _ref1.products,
    lastUpdatedFromType = _ref1.lastUpdatedFromType,
    skinId = _ref1.skinId;
  let nextCart;
  if (!cart.length || !cart.some(_ref10 => {
    let product = _ref10.product;
    return product.productId === productId && product.productVariation === productVariation && product.type === type && (!skinId || product.skinId === skinId);
  })) {
    const productToAdd = findProductByIdAndVariation({
      products,
      productVariation,
      productId,
      type,
      skinId
    });
    if (productToAdd) {
      const cartItem = createCartItem({
        product: productToAdd,
        amount: newAmount,
        lastUpdatedFromType
      });
      nextCart = [...cart, cartItem];
    } else {
      nextCart = cart;
    }
  } else {
    nextCart = cart.map(cartItem => {
      if (cartItem.product.productId === productId && cartItem.product.productVariation === productVariation && cartItem.product.type === type && (!skinId || cartItem.product.skinId === skinId)) {
        if (isAppend) {
          cartItem.amount += newAmount;
        } else {
          cartItem.amount = newAmount;
        }
      }
      return createCartItem(_objectSpread(_objectSpread({}, cartItem), {}, {
        lastUpdatedFromType
      }));
    });
  }
  return nextCart.filter(c => c.amount);
}
function createCartItem() {
  let _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    product = _ref11.product,
    amount = _ref11.amount,
    lastUpdatedFromType = _ref11.lastUpdatedFromType;
  return {
    product,
    amount,
    isAnimatingOnRender: true,
    lastUpdatedFromType
  };
}

 })(window);